import {getPublicProperty} from '@netx/core-app-next/utils/getPublicProperty';
import {AuthPref} from '../constants';

export const canRequestPasswordReset = () => {
	return !getPublicProperty(AuthPref.PASSWORD_RESET_DISABLED, true);
};

export default canRequestPasswordReset;
